import api from "../../plugins/api";

const generateUserAgreement = ({ userid, chunkId, bankIds, creditAppeal }) => {
  return api.post('/api/creditPlatform/agreement', { userid, chunkId, bankIds, creditAppeal });
};

export default generateUserAgreement;